import * as React from 'react';

import { cn } from '../../..';

import { GapProps } from './types';

type YAlignmentProps = {
  yCenter?: boolean;
  yEnd?: boolean;
  yStart?: boolean;
  yStretch?: boolean;
  yBetween?: boolean;
};

type XAlignmentProps = {
  xCenter?: boolean;
  xEnd?: boolean;
  xStart?: boolean;
  xStretch?: boolean;
  xBetween?: boolean;
};

type FlexContainerProps = React.HTMLAttributes<HTMLDivElement> &
  YAlignmentProps &
  XAlignmentProps &
  GapProps & {
    direction?: 'row' | 'column';
  } & {
    ref?: React.RefObject<HTMLDivElement | null>;
  };

const FlexContainer = ({
  className,
  xCenter,
  xEnd,
  xStart,
  xStretch,
  xBetween,
  yCenter,
  yEnd,
  yStart,
  yStretch,
  yBetween,
  gap,
  gap0,
  gap1,
  gap2,
  gap3,
  gap4,
  gap5,
  gap6,
  gap7,
  gap8,
  gap9,
  gap10,
  direction = 'row',
  ...props
}: FlexContainerProps) => (
  <div
    className={cn(
      '@FlexContainer',
      ...(direction === 'row'
        ? [
            'flex flex-row items-center',
            // y-axis
            yCenter && 'items-center',
            yEnd && 'items-end',
            yStart && 'items-start',
            yStretch && 'items-stretch',
            yBetween && 'items-between',
            // x-axis
            xCenter && 'justify-center',
            xEnd && 'justify-end',
            xStart && 'justify-start',
            xStretch && 'justify-stretch',
            xBetween && 'justify-between',
          ]
        : [
            // direction === 'column'
            'flex flex-col',
            // x-axis
            yCenter && 'justify-center',
            yEnd && 'justify-end',
            yStart && 'justify-start',
            yStretch && 'justify-stretch',
            yBetween && 'justify-between',
            // y-axis
            xCenter && 'items-center',
            xEnd && 'items-end',
            xStart && 'items-start',
            xStretch && 'items-stretch',
            xBetween && 'items-between',
          ]),
      gap0 && 'gap-0',
      gap1 && 'gap-1',
      gap2 && 'gap-2',
      gap3 && 'gap-3',
      gap4 && 'gap-4',
      gap5 && 'gap-5',
      gap6 && 'gap-6',
      gap7 && 'gap-7',
      gap8 && 'gap-8',
      gap9 && 'gap-9',
      gap10 && 'gap-10',
      className,
    )}
    {...props}
    style={{ ...props.style, gap }}
  />
);

export const Row = ({
  className,
  ...props
}: Omit<FlexContainerProps, 'direction'>) => (
  <FlexContainer {...props} className={cn('@Row', className)} direction="row" />
);

export const Col = ({
  className,
  ...props
}: Omit<FlexContainerProps, 'direction'>) => (
  <FlexContainer
    {...props}
    className={cn('@Col', className)}
    direction="column"
  />
);
